import { Component, OnDestroy, OnInit } from "@angular/core";
import { DomSanitizer } from "@angular/platform-browser";
import { Router, NavigationEnd, ActivatedRoute } from "@angular/router";
import { environment as env } from "@env/environment";
import { filter } from "rxjs/operators";
import { ChatEmitterService } from "./core/services/chat-emitter.service";
import { ChatService, SignalRService } from "./core/services/chat.service";
import { AppConfig } from "./core/Utilities/app-config.service";
import { RouteUrl } from "./core/utilities/route-url.service";
declare var gtag;
import * as _ from "lodash";
import { FindCRSService } from './core';
import { AuthenticationService } from './core/services/authentication.service';

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.scss"],
})
export class AppComponent implements OnInit, OnDestroy {
  title = "Find a CRS";
  fromParent = true;
  openuserChat = false;
  isOpenMessaging = false;
  isOpenMessage = false;
  openMessage = false;
  openUserSearch = false;
  openActiveChat = false;
  public displayChatIcon = false;
  openChatID: any;

  fullNamePlaceholderText = "Search Agent Name";
  locationPlaceholderText = "State, City or Zip";
  showAlertForLocation = false;
  showInvalidSearch = false;
  searchkwdName = "";
  searchkwdLocation = "";
  searchSubmitted = false;
  selectedAgentName = "";
  selectedLocationName = "";
  receiverInfo: any;

  public showArchiveUserLimit = 0;
  public showArchiveUserCounter = 0;
  public isShowLessArchiveUser = false;

  constructor(
    private router: Router,
    public appConfig: AppConfig,
    private routeUrl: RouteUrl,
    public chatService: ChatService,
    private sanit: DomSanitizer,
    private chatEmitterService: ChatEmitterService,
    private activatedRoute: ActivatedRoute,
    private signalRService: SignalRService,
    private _findcsrService: FindCRSService,
    private authService: AuthenticationService,
  ) {

    this.activatedRoute.queryParams.subscribe(params => {
      if (params.env) {
        window.localStorage.setItem("testEnv", params.env);
      }
    });
    this.showArchiveUserLimit = 3;
    this.showArchiveUserCounter = this.showArchiveUserLimit;

    this.showSpecificRouteIcons();
    this.router.events.subscribe(() => {
      this.showSpecificRouteIcons();
    });
    const navEndEvents = router.events.pipe(
      filter((event) => event instanceof NavigationEnd)
    );
    if (env.envName != "BETA") return; //enable GA only in production
    // subscribe to router events and send page views to Google Analytics
    navEndEvents.subscribe((event: NavigationEnd) => {
      gtag("config", "G-X8CV1Z5YPY", {
        page_path: event.urlAfterRedirects,
      });
    });
  }

  ngOnInit() {
    if (this.appConfig.SharedComponent.userLoggedIn) {
      this.getActiveChatList();
      this.chatService.setuserArchiveChat();
    }

    if (this.chatEmitterService.subscriptionObject === undefined) {
      this.chatEmitterService.subscriptionObject = this.chatEmitterService.invokeChat.subscribe(
        (data) => {
          this.isOpenMessage = true;
          this.openChatID = 0;
          if (data) {
            this.receiverInfo = {
              UserID: data.ID,
              UserImageURL: data.ImageURL,
              UserIsActiveNow: false,
              UserName: data.FirstName + " " + data.LastName,
            };
          }
        }
      );
    }
  }

  getImgsSanitized(imageURL: any) {
    if (imageURL) {
      return this.sanit.bypassSecurityTrustStyle(
        "url(" + imageURL + "), url(/assets/images/user-icon.png)"
      );
    } else {
      return this.sanit.bypassSecurityTrustStyle(
        "url(/assets/images/user-icon.png)"
      );
    }
  }

  showSpecificRouteIcons() {
    this.displayChatIcon =
      this.router.url !== "/direct-message" &&
      !this.router.url.includes("/user/direct/message/");
  }

  searchUser() {
    this.showAlertForLocation = false;
    this.showInvalidSearch = false;

    if (!this.searchkwdName && !this.searchkwdLocation) {
      this.searchSubmitted = true;
      this.showInvalidSearch = true;
      return;
    }

    if (
      this.searchkwdName.trim().length === 0 &&
      this.searchkwdLocation.trim().length === 0
    ) {
      this.showInvalidSearch = true;
      return;
    }

    // // Location Must be selected from auto complete search in case of search by name is blank
    if (
      this.searchkwdLocation !== "" &&
      this.selectedLocationName !== this.searchkwdLocation
    ) {
      if (!this.searchkwdName || this.searchkwdName.trim().length > 0) {
        this.showAlertForLocation = true;
        return;
      }
    }

    this.searchSubmitted = false;
    this.openUserSearch = false;

    // this.router.navigateByUrl(
    //   "/" +
    //   this.routeUrl.agentResult +
    //   "?kwdName=" +
    //   this.searchkwdName.trim() +
    //   "&kwdLocation=" +
    //   this.searchkwdLocation.trim()
    // );

    this._findcsrService
      .searchAgents(this.searchkwdName, this.searchkwdLocation, 10)
      .subscribe(
        (x: any) => {
          const results = x;
          if (results != null && results.TotalResultCount > 0 && results.Members.length > 0) {
            const data = results.Members[0];
            if (data.ID !== +this.authService.getUserInformation()["ID"]) {
              this.isOpenMessage = true;
              this.openChatID = 0;
              if (data) {
                this.receiverInfo = {
                  UserID: data.ID,
                  UserImageURL: data.ImageURL,
                  UserIsActiveNow: false,
                  UserName: data.FirstName + " " + data.LastName,
                };
              }
            }
          }
        });
  }

  searchKeyWorkForName(keyWork: any) {
    this.searchkwdName = keyWork;
    if (this.searchkwdName) {
      if (this.searchkwdName.trim().length > 0) {
        this.searchSubmitted = false;
      }
    }
  }

  searchKeyWorkForLocation(keyWork: any) {
    this.searchkwdLocation = keyWork;
    if (this.searchkwdLocation) {
      if (this.searchkwdLocation.trim().length > 0) {
        this.searchSubmitted = false;
      }
    }

    // // this.showAlertForLocation = false;
    this.showInvalidSearch = false;
  }

  selectedItem(item: any, by: string = "") {
    if (by === "name") {
      this.selectedAgentName = item.item;
      this.searchkwdName = this.selectedAgentName;
    } else if (by === "location") {
      this.selectedLocationName = item.value;
      this.searchkwdLocation = this.selectedLocationName;
      this.showAlertForLocation = false;
      this.showInvalidSearch = false;
    }
  }

  goToDirectChats() {
    if (_.size(this.chatService.SharedChatComponent.userActiveChat) === 1) {
      this.router.navigate([`user/direct/message/${_.get(this.chatService.SharedChatComponent, 'userActiveChat[0].ChatId')}`]);
    } else {
      this.router.navigate(["/direct-message"]);
    }
  }

  openChatWindow() {
    this.openuserChat = !this.openuserChat;
  }

  toggleMessaging() {
    this.isOpenMessaging = !this.isOpenMessaging;
    this.openMessage = this.isOpenMessaging === true;
  }

  closeMessaging() {
    this.isOpenMessaging = false;
  }

  toggleMessage(id) {
    this.receiverInfo = null;
    this.openUserSearch = false;
    if (this.openChatID !== id) {
      this.isOpenMessage = true;
      this.openChatID = id;
    } else {
      this.isOpenMessage = !this.isOpenMessage;
    }
  }

  closeMessage(value) {
    this.isOpenMessage = false;
    if (value) {
      this.getActiveChatList();
    }
  }

  toggleUserSearch() {
    this.openUserSearch = !this.openUserSearch;
  }

  toggleActiveUserChat() {
    this.openActiveChat = !this.openActiveChat;
    if (!this.openActiveChat) {
      this.isOpenMessage = false;
    }
  }

  startConversation() {
    this.openUserSearch = !this.openUserSearch;
    if (this.openUserSearch) {
      this.chatService.setuserArchiveChat();
    }
  }

  getActiveChatList() {
    this.chatService.getActiveUsersChat();
  }

  archiveChat(e, id) {
    e.stopPropagation();
    if (this.openChatID === id) {
      this.isOpenMessage = false;
    }
    this.chatService.archiveChat(id).subscribe((result) => {
      this.getActiveChatList();
      this.chatService.setuserArchiveChat();
    });
  }

  onShowMoreLessClick() {
    this.isShowLessArchiveUser = !this.isShowLessArchiveUser;
    if (this.isShowLessArchiveUser) {
      this.showArchiveUserCounter = this.chatService.SharedChatComponent.userActiveChat.length;
    } else {
      this.showArchiveUserCounter = this.showArchiveUserLimit;
    }
  }

  ngOnDestroy() {
    this.signalRService.stopConnection();
  }

  hasFile(message) {
    return _.startsWith(message, "<Attechment") ? 'Attachment' : message;
  }
}
